import React, { useEffect, useState } from 'react';
import { SiteInfo } from '@/globals';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  const [protocol, setProtocol] = useState('');
  const [domain, setDomain] = useState('');
  const [port, setPort] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setProtocol(window.location.protocol);
      setDomain(window.location.hostname?.split(".")?.slice(1).join("."));
      
      if(window.location.port !== '80' && window.location.port !== '443') {
        setPort(':' + window.location.port);
      }
    }
  }, []);

  return (
    <footer className="mt-24 bg-black text-primary-foreground text-center">
      <div className="p-6 text-left">
        <div className="text-lg font-bold">
          <a href={"/"}>{SiteInfo.siteName}</a>
        </div>

        <div className="text-sm mt-2">{t("footerCopyright")}</div>
        <div className="text-sm">{t("footerText")}</div>
        <div className="text-sm mt-2 underline">
          <a href="/about" className="mr-4">{t("about")}</a>
          <a href="/termsOfService" className="mr-4">{t("termsOfService")}</a>
          <a href="/privacyPolicy">{t("privacyPolicy")}</a>
        </div>
        {/* <div className="mt-3 text-sm flex flex-wrap">
          { domain &&
          <>
            <a href={`${protocol}//www.${domain}${port}`}>
              <span className="text-sm text-gray-200 mr-4 my-1 font-bold block">🇺🇸English (US)</span>
            </a>
            <a href={`${protocol}//es.${domain}${port}`}>
              <span className="text-sm text-gray-200 mr-4 my-1 font-bold block">🇪🇸Español (España)</span>
            </a>
            <a href={`${protocol}//ru.${domain}${port}`}>
              <span className="text-sm text-gray-200 mr-4 my-1 font-bold block">🇷🇺Русский</span>
            </a>
            <a href={`${protocol}//jp.${domain}${port}`}>
              <span className="text-sm text-gray-200 mr-4 my-1 font-bold block">🇯🇵日本語</span>
            </a>
            <a href={`${protocol}//kr.${domain}${port}`}>
              <span className="text-sm text-gray-200 my-1 font-bold block">🇰🇷한국어</span>
            </a>
          </>
          }
        </div> */}
      </div>
    </footer>
  )
}